import { Parallax } from 'react-scroll-parallax';
import styles from './BackgroundParallax.module.scss';

type BackgroundParallaxProps = {
  children: JSX.Element | JSX.Element[]; // TODO: use ReactNode when Parallax supports it (node_modules/react-scroll-parallax/dist/components/Parallax/Parallax.d.ts)
};

const BackgroundParallax = ({ children }: BackgroundParallaxProps) => {
  return (
    <Parallax className={styles.base} translateY={[-50, 50]}>
      {children}
    </Parallax>
  );
};

export default BackgroundParallax;
